import { Button, Result } from 'antd'
import { useRouteError } from 'react-router-dom'
import { isChunkLoadError } from '@/lib/chunk-load-recovery'

export default function RouteErrorPage() {
  const error = useRouteError()
  const isLoadFailure = isChunkLoadError(error)

  return (
    <div data-c="RouteErrorPage" className="flex min-h-screen items-center justify-center bg-color-bg-container p-6">
      <Result
        status="warning"
        title={isLoadFailure ? '页面加载失败' : '页面暂时无法显示'}
        subTitle={isLoadFailure
          ? '页面可能已更新或网络连接中断，请检查网络后刷新页面。'
          : '请刷新页面重试；如果问题持续，请联系管理员。'}
        extra={<Button type="primary" onClick={() => window.location.reload()}>刷新页面</Button>}
      />
    </div>
  )
}
